import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';

@Injectable({
  providedIn: 'root'
})
export class ModeratorGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const user = this.sessionService.getUser() || null;

    if(user.user.roles.includes("MODERATOR") || user.user.roles.includes("ADMIN") || user.user.roles.includes("USER_REPORT")){
      return true;
    }

    return false;

    /*
    if (!localStorage.getItem("roles").includes("ADMIN")) {
      this.router.navigate(["/pv/request-day"]);
      return false;
    }
    return true;
    */
  }
}
